// src/components/ScrollRestoration.jsx
//
// Renderless component that wires up useScrollRestoration. Must be
// mounted inside a <Router> subtree. One instance per app.

import useScrollRestoration from '../hooks/useScrollRestoration';

const ScrollRestoration = () => {
  useScrollRestoration();
  return null;
};

export default ScrollRestoration;
